import { createFileRoute } from "@tanstack/react-router";
import { LadderBuilder } from "@/components/notices/ladders/ladder-builder";

export const Route = createFileRoute("/_authenticated/notices/rules/$ladderId/")({
  component: NoticeLadderBuilderRoute,
});

/** One escalation ladder's builder, with its live status rail. */
function NoticeLadderBuilderRoute() {
  const { ladderId } = Route.useParams();
  return <LadderBuilder ladderId={ladderId} />;
}
